/**
 * Created by fers on 27.04.16.
 */
import PropTypes from 'prop-types';
import {declareEditEntity} from '../../../common/fw/MetaDataHelper.ts';
import {ParentBox} from './ParentBox.react';
import config from '../../../common/config';

/**
 * Parent component that is used in all boxes and templates that need to work with fields
 */
export class ParentTemplate extends ParentBox {

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

	static isEmpty = ParentBox.isEmpty;

    prepareMetadata() {
        let list = {
            "dativery": {
                name: "",
                type: "string"
            },
            "organisation": {
                name: "Organisation",
                title: config.PRODUCT_NAME + " Organisation",
                type: "string"
            },
            "channel": {
                name: "Channel",
                title: config.PRODUCT_NAME + " Channel",
                type: "string"
            }
        };

        if (this.props.viewWithData.entityDef && this.props.viewWithData.entityDef.allFieldDefs) {
            this.props.viewWithData.entityDef.allFieldDefs.edges.map(({node}) => {
                let fieldDef = node;

                let entity = {
                    name: fieldDef['shortName'] ? fieldDef['shortName'] : fieldDef['name'],
					name_f: fieldDef.name,
					name_l: fieldDef.name_l,
					shortName: fieldDef.shortName,
					shortName_l: fieldDef.shortName_l,
                    title: fieldDef['shortName'] ? fieldDef['name'] : null,
                    fieldDef: fieldDef['realId'],
                    description: fieldDef['description'],
                    type: fieldDef['type'],
                };

                if (fieldDef['realId'] === "key") {
                    entity['primary'] = true;
                }

                list[fieldDef['realId']] = entity;
            });
        }

        let entityDef = this.props.viewWithData.entityDef;

        let metaData = {
            entity: entityDef ? entityDef['key'] : '?',
            name: entityDef ? entityDef['name'] : '?',
            fields: list
        };

        this.metaData = declareEditEntity(metaData);
    }

    getMetaData() {
        if (!this.metaData) {
           this.prepareMetadata();
        }

        return this.metaData;
    }

}
